import { render, staticRenderFns } from "./VersionEdit.vue?vue&type=template&id=987d35f4&scoped=true&"
import script from "./VersionEdit.vue?vue&type=script&lang=js&"
export * from "./VersionEdit.vue?vue&type=script&lang=js&"
import style0 from "./VersionEdit.vue?vue&type=style&index=0&id=987d35f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987d35f4",
  null
  
)

export default component.exports